"use client";
import BuyNowCart from "@/components/common/BuyNowCart";
import BannerVideo from "@/components/common/video";
import SignupForFree from "@/components/landingpage/SignupForFree";
import MainLayout from "@/components/layout/mainLayout";
import HowWeMakeWhiskyDetails from "@/components/newoctavecollection/HowWeMakeWhiskyDetails";
import NewOctaveBanner from "@/components/newoctavecollection/NewOctaveBanner";
import NewOctaveCollectionDetails from "@/components/newoctavecollection/NewOctaveCollectionDetails";
import ScoMeta from "@/components/scometa";
import SingleCaskWhiskyCollection from "@/components/singlecask/SingleCaskWhiskyCollection";
import { getCheckoutLineItems } from "@/util/utils";
import { useEffect, useState } from "react";
import { formatImageUrl } from "../../../helper/helper";
import { useAppCommonStore } from "@/zustand/appCommon";
import OwnACaskModal from "@/components/newoctavecollection/OwnACaskModal";
import ThanksCaskModal from "@/components/newoctavecollection/ThanksCaskModal";
import NewOctaveJourneySection from "@/components/newoctavecollection/NewOctaveJourneySection";
import DuncanTaylorVideo from "@/components/common/duncanTaylorVideo";
import OwnACask from "@/components/newoctavecollection/OwnACask";
import NewOctaveCollectionVideoSection from "@/components/newoctavecollection/NewOctaveCollectionVideoSection";
import CraftingOctaveSection from "@/components/newoctavecollection/CraftingOctaveSection";
import NewOctaveWhiskyCollection from "@/components/newoctavecollection/NewOctaveWhiskyCollection";
import Galary from "@/components/common/galaryslider";

const NewOctaveCollection = (props: any) => {
  const { data, meta } = props;

  const [newOctaveCollectionData, setNewOctaveCollectionData]: any =
    useState(null);

  const {
    checkout,
    setCheckout,
    selectedCountry,
    updateQuantityInCart,
    removeLineItemInCart,
    openModal,
    toggleCartSidebar,
  } = useAppCommonStore((state: any) => ({
    checkout: state.checkout,
    setCheckout: state.setCheckout,
    selectedCountry: state.selectedCountry,
    updateQuantityInCart: state.updateQuantityInCart,
    removeLineItemInCart: state.removeLineItemInCart,
    openModal: state.openModal,
    toggleCartSidebar: state.toggleCartSidebar,
  }));
  const [openOwnCaskModal, setOpenOwnCaskModal]: any = useState(false);
  const [openCaskThanksModal, setOpenCaskThanksModal]: any = useState(false);

  useEffect(() => {
    getCheckoutLineItems(selectedCountry.value).then((res) => {
      setCheckout({
        ...res,
      });
    });
  }, []);

  useEffect(() => {
    if (data) {
      setNewOctaveCollectionData(data?.data?.attributes?.blocks);
    }
  }, [data]);

  const renderNewOctaveCollectionPage = () => {
    return (
      <>
        {newOctaveCollectionData && newOctaveCollectionData.length > 0
          ? newOctaveCollectionData.map((content: any, index: any) => {
              switch (content.__component) {
                case "sections.banner":
                  return (
                    <NewOctaveBanner
                      srcURL={content?.video_link}
                      data={content}
                      key={content?.id + index}
                    />
                    // <NewOctaveCollectionVideoSection
                    //   srcURL={content?.video_link}
                    //   data={content}
                    //   key={content?.id + index}
                    // />
                  );

                case "octave.how-we-craft":
                  return (
                    <NewOctaveCollectionDetails
                      key={content?.id + index}
                      data={content}
                    />
                  );
                case "octave.new-octave-whisky":
                  return (
                    <CraftingOctaveSection
                      key={content?.id + index}
                      data={content}
                    />
                  );

                case "octave.our-collections":
                  return (
                    <NewOctaveWhiskyCollection
                      key={content?.id + index}
                      data={content}
                      name={"new-octave"}
                    />
                  );

                case "octave.journey":
                  return (
                    <div
                      className="new_octave_collection_journey_section"
                      id="journery-section"
                    >
                      <NewOctaveJourneySection
                        data={content}
                        key={content?.id + index}
                      />
                    </div>
                  );

                case "octave.form-section":
                  return (
                    <div id="cask-section">
                      <OwnACask
                        data={content}
                        openOwnCaskModal={openOwnCaskModal}
                        setOpenCaskThanksModal={setOpenCaskThanksModal}
                        pagename={"new-octave"}
                      />
                    </div>
                  );
                case "sections.gallery":
                  return (
                    <Galary
                      data={content}
                      key={content?.id + index}
                      pagename={"new-octave"}
                    />
                  );

                default:
                  return null;
              }
            })
          : null}
      </>
    );
  };

  let bgImage: any;

  if (typeof window !== "undefined") {
    bgImage = formatImageUrl(
      window.innerWidth <= 760
        ? props?.data?.data?.attributes?.background_mobile?.data?.attributes
            ?.url
        : props?.data?.data?.attributes?.background?.data?.attributes?.url
    );
  }

  const toggleOwnCaskModal = () => {
    setOpenOwnCaskModal(!openOwnCaskModal);
  };
  return (
    <>
      {/* <button
        className="own_octave_btn new_octave_collection_btn"
        onClick={toggleOwnCaskModal}
      >
        <h3 className="own_bottle_an_octave">
          BOTTLE <br />
          AN OCTAVE CASK
        </h3>
      </button>
      <OwnACaskModal
        openOwnCaskModal={openOwnCaskModal}
        toggleOwnCaskModal={toggleOwnCaskModal}
        setOpenCaskThanksModal={setOpenCaskThanksModal}
      />*/}
      <ThanksCaskModal
        openModal={openCaskThanksModal}
        setOpenModal={setOpenCaskThanksModal}
      />
      <BuyNowCart
        countryCode={selectedCountry.value}
        openModal={openModal}
        toggleCartSidebar={toggleCartSidebar}
        checkout={checkout}
        updateQuantityInCart={updateQuantityInCart}
        removeLineItemInCart={removeLineItemInCart}
      />
      <head>
        <ScoMeta meta={meta ? meta : {}} />
      </head>
      <MainLayout checkout={checkout} toggleCartSidebar={toggleCartSidebar}>
        <div
          className="single-cask-collection new_octave_collection_container"
          style={{
            backgroundImage: `url(${bgImage})`,
          }}
        >
          {newOctaveCollectionData && renderNewOctaveCollectionPage()}
        </div>
      </MainLayout>
    </>
  );
};

export default NewOctaveCollection;
